module.exports = "/_next/static/videos/video-9b3e39612e748ee5c715b862a115a832.mp4";